//完整写法应该是：import Vue from "../node_modules/vue/dist/vue.js";
import Vue from 'vue'
import App from './App.vue'
//完整写法是：import router from './route.js';
import router from './router'
import 'font-awesome/css/font-awesome.min.css'
//ajax实现前后端通信，进而实现前后端的分��?
import axios from 'axios'
//对象相互转换json
import qs from 'qs'
//从common.js引入一些通用的方��?
import {
    getCurDate,
    setSessionStorage,
    getSessionStorage,
    removeSessionStorage,
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage
} from './common.js'
Vue.config.productionTip = false
//设置axios的基础url部分
axios.defaults.baseURL ='http://175.178.217.71:8787/elm';
//将axios挂载到vue实例上，使用时就可以 this.$axios 这样使用��?,下面的一系列也同��?
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$getCurDate = getCurDate;
Vue.prototype.$setSessionStorage = setSessionStorage;
Vue.prototype.$getSessionStorage = getSessionStorage;
Vue.prototype.$removeSessionStorage = removeSessionStorage;
Vue.prototype.$setLocalStorage = setLocalStorage;
Vue.prototype.$getLocalStorage = getLocalStorage;
Vue.prototype.$removeLocalStorage = removeLocalStorage;
// 全局前置路由守卫————初始化的时候、每次路由切换之前被调用
router.beforeEach(function (to, from, next) {
    let user = sessionStorage.getItem('user');
    //除了登录、注册、首页、商家列表、商家信息之外，都需要判断是否登��?
    if (!
        (to.path == '/' || to.path == '/index' || to.path == '/businessList' ||
            to.path == '/businessInfo' || to.path == '/login' ||
            to.path == '/register')) {
        if (user == null) {
            router.push('/login');
            location.reload();
        }
    }
    next();
});



new Vue({
    //传入router挂载路由
    router,
    //简化写法，就表示了创建一个APP组件
    render: h => h(App)
}).$mount('#app')//挂载到id为app的组��?